import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class OrganPricelistProvinceModel extends BaseModel {

    constructor() {
        super({ 
                name: "organ_pricelist_province",
                tableName: 'document', 
                label: "Bảng giá tỉnh", 
                display_key: 'code_system', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            code_system: {
                name: 'code_system', 
                type: "String",
                label: 'Mã VB hệ thống',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            code_office: {
                name: 'code_office', 
                type: "String",
                label: 'Mã văn phòng',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            code_agency: {
                name: 'code_agency', 
                type: "String",
                label: 'Mã cơ quan',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            ward_ref: { 
                refs: 'ward {id name}',
                display: false
            },
            display_ward: { 
                name: "display_ward", 
                label: "Phường / Xã",
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_ward = '';
                    if(data.ward !== undefined && data.ward !== null){
                        data.display_ward = data.ward.name;
                    }
                }
            },
            district_ref: { 
                refs: 'district {id name}',
                display: false
            },
            display_district: {
                name: "display_district", 
                label: "Quận / Huyện",
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_district = '';
                    if(data.district !== undefined && data.district !== null){
                        data.display_district = data.district.name;
                    }
                }
            },
            state_ref: { 
                refs: 'state {id name}',
                display: false
            },
            display_state: {
                name: "display_state", 
                label: 'Tỉnh / Thành phố Tống Đạt',
                width: 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_state = '';
                    if(data.state !== undefined && data.state !== null){
                        data.display_state = data.state.name;
                    }
                }
            },
            vplk_ref: { 
                refs: 'office_vplk {id name}',
                display: false
            },
            name_vplk: {
                name: 'name_vplk', 
                label: 'Văn phòng liên kết',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.name_vplk = '';
                    if(data.office_vplk !== undefined && data.office_vplk !== null){
                        data.name_vplk = data.office_vplk.name;
                    }
                }
            },
            status_vb_ref: { 
                refs: 'status_document {id name ordinal}',
                display: false
            },
            status_vb: {
                name: "status_vb", 
                label: 'Trạng thái VB',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.status_vb = '';
                    if(data.status_document !== undefined && data.status_document !== null){
                        data.status_vb = data.status_document.name;
                    }
                }
            },
            cost_document: {
                name: 'cost_document', 
                type: "InputCurrency",
                label: 'Giá VB đi tỉnh cơ quan phải trả (VND)',
                width: 11,
                class: "center",
                // display: false
            },
        },)
    }

}